import * as React from "react";
const SvgFiRrCodeSimple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9 22a1 1 0 0 1-.692-.278l-7.121-6.828a4.01 4.01 0 0 1-.015-5.672l7.131-6.939a.999.999 0 1 1 1.394 1.434l-7.121 6.93a2 2 0 0 0 .01 2.818l7.106 6.813A1 1 0 0 1 9 22m6.698-.284 7.112-6.94a4.01 4.01 0 0 0-.014-5.67l-7.103-6.827a1 1 0 0 0-1.386 1.442l7.089 6.811c.779.78.779 2.05.009 2.82l-7.104 6.932a1 1 0 1 0 1.396 1.432z"
    />
  </svg>
);
export default SvgFiRrCodeSimple;
